import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Globe = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M21 12.438a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c-2.21 0-4-4.03-4-9s1.79-9 4-9m0 18c2.21 0 4-4.03 4-9s-1.79-9-4-9m-9 9a9 9 0 0 1 9-9'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
      />
    ) : (
      <>
        <path
          d='M2.027 11.688h4.984c.078-2.545.549-4.862 1.293-6.614.408-.96.913-1.786 1.512-2.382l.02-.02c-4.246.937-7.48 4.572-7.809 9.016'
          fill='currentColor'
        />
        <path
          d='M2.027 13.188c.33 4.443 3.563 8.079 7.81 9.015l-.02-.02c-.6-.596-1.105-1.42-1.513-2.38-.744-1.753-1.215-4.07-1.293-6.615z'
          fill='currentColor'
        />
        <path
          d='M14.163 22.203c4.246-.936 7.48-4.572 7.809-9.015h-4.984c-.078 2.544-.548 4.862-1.293 6.614-.408.96-.913 1.785-1.512 2.382z'
          fill='currentColor'
        />
        <path
          d='M21.972 11.688a10.01 10.01 0 0 0-7.809-9.015l.02.02c.6.595 1.104 1.42 1.512 2.38.745 1.753 1.215 4.07 1.293 6.615z'
          fill='currentColor'
        />
        <path
          d='M13.125 3.755c-.415-.412-.794-.567-1.125-.567s-.71.155-1.126.567c-.418.416-.828 1.056-1.19 1.905-.652 1.537-1.095 3.648-1.172 6.028h6.976c-.078-2.38-.52-4.491-1.173-6.028-.361-.85-.772-1.489-1.19-1.905'
          fill='currentColor'
        />
        <path
          d='M14.315 19.216c.653-1.537 1.095-3.648 1.173-6.028H8.512c.077 2.38.52 4.49 1.173 6.028.36.85.771 1.489 1.19 1.904.414.413.794.568 1.125.568s.71-.155 1.125-.567c.418-.416.829-1.056 1.19-1.905'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
